import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidComponent } from './valid.component';
import { ValidService } from './valid.service';

@NgModule({
  declarations: [ValidComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    ValidService
  ]
})
export class ValidModule { }
